import { render, staticRenderFns } from "./BrushesDD.vue?vue&type=template&id=638a97d1&scoped=true"
import script from "./BrushesDD.vue?vue&type=script&lang=js"
export * from "./BrushesDD.vue?vue&type=script&lang=js"
import style0 from "./BrushesDD.vue?vue&type=style&index=0&id=638a97d1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638a97d1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('638a97d1')) {
      api.createRecord('638a97d1', component.options)
    } else {
      api.reload('638a97d1', component.options)
    }
    module.hot.accept("./BrushesDD.vue?vue&type=template&id=638a97d1&scoped=true", function () {
      api.rerender('638a97d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/svg-editor/BrushesDD.vue"
export default component.exports